/**
 * @file
 * Show hidden rows
 *
 */
(function ($) {

	Drupal.behaviors.marketAreas = {
        attach: function (context, settings) {
            const url = new URL(location.href);
            const cr = url.searchParams.get("cr") === "true" ? true : false;

            $("#block-treston-marketsregionsbar .close-button", context).on("click", function() {
                $(".responsive-w.thing-wrapper").removeClass("with-market-region-bar");
                $("#block-treston-marketsregionsbar").removeClass("visible");
                setCookie("market-region-notice-closed", true, 30);
            });

            if(url.searchParams.get("manual-redirect") == "true") {
                //console.log("Manual redirect");
                setCookie("market-region-manually-redirected", true, 30);
                $("#block-treston-marketsregionsbar").removeClass("visible");
            }

            // Detect bots and stop redirect in case the User Agent is a crawler.
            var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
            var re = new RegExp(botPattern, 'i');
            var userAgent = navigator.userAgent; 
            if (re.test(userAgent)) {
                return null
            }


            if(getCookie('market-region-notice-closed') != "true" && getCookie('market-region-manually-redirected') != "true") {
                //console.log("Let's do this again");
                $.get("/marketregion/get-market-region?ssid=23Dts923-" + new Date().getTime(), function(data){
                    var jsonData = data;
                    var isFront = $("BODY").hasClass('path-frontpage');
                    //console.log(isFront);
                    if(jsonData.language === "en-us" && jsonData.country !== "US") {
                        $("#block-treston-marketsregionsbar .content .message").html(jsonData.content);
                        $(".responsive-w.thing-wrapper").addClass("with-market-region-bar");
                        $("#block-treston-marketsregionsbar").addClass("visible");
                    }
                    else if (jsonData.language === "en" && jsonData.country === "US") {
                        if(isFront) {
                            window.location.href = "https://www.treston.us?cr=true"; // cr => country redirected
                        }
                        $("#block-treston-marketsregionsbar .content .message").html(jsonData.content);
                        $(".responsive-w.thing-wrapper").addClass("with-market-region-bar");
                        $("#block-treston-marketsregionsbar").addClass("visible");
                    }
                    else if(cr == true) {
                        $("#block-treston-marketsregionsbar .content .message").html(jsonData.content);
                        $(".responsive-w.thing-wrapper").addClass("with-market-region-bar");
                        $("#block-treston-marketsregionsbar").addClass("visible");
                    }
                });
            };
        }
    };

})(jQuery);

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}